// Generated by Claude Code
import { Type } from 'class-transformer'
import { BaseIdModel } from '#core/entities/shared/BaseModels.ts'
import { Permission } from '#core/entities/auth/roles/Permission.ts'

/** A machine identity that authenticates with a client id + secret; never logs in to the app. */
export default class ApiUser extends BaseIdModel {
  name: string = ''
  /** The client id. */
  identifier: string = ''
  enabled: boolean = true
  @Type(() => Date)
  last_logged_in: Date | null = null
  @Type(() => Date)
  created_at: Date | null = null
  // The three assignment fields are omitted (undefined) when the caller lacks Users Edit.
  role_id?: string | null
  role_name?: string | null
  @Type(() => Permission)
  personal_permissions?: Permission[] | null
}
